export default __webpack_public_path__ + "static/media/bg_pricing.d978aa18.png";